// tourStorage — versioned localStorage layer for "has the user seen this
// tour?" flags.
//
// Versioned keys (`<prefix>.<id>.v<version>`) let us re-show a tour after a
// material content update by bumping its version, without forcing a global
// reset. localStorage is wrapped in try/catch so private-browsing or
// quota-exceeded environments degrade gracefully — failures fall back to an
// in-memory map for the current session and the tour will simply re-show
// next visit.

const COMPLETION_PREFIX = 'dataPlatform.tour';

const memoryFallback = new Map<string, string>();

function safeGet(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return memoryFallback.get(key) ?? null;
  }
}

function safeSet(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    memoryFallback.set(key, value);
  }
}

function completionKey(tourId: string, version: number): string {
  return `${COMPLETION_PREFIX}.${tourId}.v${version}`;
}

export function isTourCompleted(tourId: string, version: number): boolean {
  return safeGet(completionKey(tourId, version)) === '1';
}

export function markTourCompleted(tourId: string, version: number): void {
  safeSet(completionKey(tourId, version), '1');
}
